import branches from "@/components/fulfillment/sample.branches";

export default {
  namespaced: true,
  state: {
    branches: branches
  },
  getters: {
    branches: state => state.branches
  }
}
